import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/assets/css/spacing.css';

import '../src/assets/css/line-awesome.min.css';
import '../src/assets/css/themify-icons.css';
import '../src/assets/css/animate.css';
import 'react-accessible-accordion/dist/fancy-example.css';
import 'react-modal-video/scss/modal-video.scss';

import 'owl.carousel/dist/assets/owl.carousel.css';  
import 'owl.carousel/dist/assets/owl.theme.default.css';  
 
import 'antd/dist/antd.css';
import '../src/assets/css/theme.min.css';